import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { CHECK_PROMOTION_AVAILABLE_FOR_USER, FANZONES } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import { buildAnchorLink, buildAnchorCheckoutLink } from '../../utils/helpers';
import AnchorFanzone from '../FanZone/AnchorFanzone';

import './css/DiscountPage.css';
import '../../css/utils/flex.css';
import styles from './css/AnchorsList.module.css';
import EmailValidatorField from './EmailValidatorField';
import { PROMO_CODES } from '../../constants/promoCodes';

function DiscountsPage(props) {
  const { activeCampaign, user, isCyberMondayPromo, className, isChristmasPromo } = props;
  const { affiliateCode } = activeCampaign || {};
  const { authenticated = false } = user || {};
  const [anchors, setAnchors] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState('');
  const [hash, setHash] = useState('');

  const checkActiveSubscriptionsAndFilterAnchors = useCallback((anchorsList) => {
    if (props.user?.user?.account?.affiliateCode === affiliateCode) {
      return [];
    }
    const anchorsNotSubscribedTo = anchorsList.filter((anchor) =>
      !user.user.account.anchorSubscriptions.
        find((a) => parseInt(a.subCategory, 10) === anchor.id));

    return anchorsNotSubscribedTo;
  }, [affiliateCode, props.user?.user?.account?.affiliateCode, user?.user?.account?.anchorSubscriptions]);

  const validateHashFromURL = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('code') || params.has('promoHash')) {
      const HASH_CODE = params.get('code') || params.get('promoHash');
      setHash(HASH_CODE);
      const URL = CHECK_PROMOTION_AVAILABLE_FOR_USER;
      callApi(URL, 'GET', { hash: HASH_CODE }).then((res) => {
        if (res.status === 200 && res.data === 'OK') {
          setErrorMessage('');

        } else {
          setErrorMessage('This link is no longer valid!');
        }
      }).
        catch((err) => console.error(err));
    }
  }, []);

  useEffect(() => {
    callApi(FANZONES, 'get').then((res) => {
      if (!user?.authenticated) {
        setAnchors(res.data);
      } else {
        setAnchors(checkActiveSubscriptionsAndFilterAnchors(res.data));
      }
    }).catch(() => {
      setAnchors(undefined);
    });

    validateHashFromURL();
  }, []);

  const getAnchorCheckoutURL = useCallback((anchor) => {
    if (isChristmasPromo) {
      return buildAnchorCheckoutLink(anchor?.id, buildAnchorLink(anchor), hash, PROMO_CODES.CHRISTMAS_FANZONE_2023);
    }

    return buildAnchorCheckoutLink(anchor.id, buildAnchorLink(anchor), hash, '');
  }, [hash, isChristmasPromo]);

  const renderAnchorsList = useCallback(() => {
    if (anchors?.length > 0) {
      return (
        <AnchorFanzone
          checkoutLink={getAnchorCheckoutURL}
          classes={'flex justify-center'}
          customStyles={styles}
          fanzones={anchors}
          isDiscountPage={true}
        />
      );
    }

    return (
      <div className="error-msg flex justify-center items-center">
        <h1 className="text-center white">Sorry! You are not eligible for this promotion</h1>
      </div>
    );
  }, [anchors, getAnchorCheckoutURL]);

  return (
    <div className={`content bg-dark ${className}`}>
      <div className="bg-dark">
        <div className="fanzone-offer">
          <div className={`fanzone-offer-header ${className}`} />
          {!isCyberMondayPromo &&
            <ul className="flex justify-around items-center fanzone-benefits-list">
              <li>Low Monthly Subscription</li>
              <li>Access to exclusive content</li>
              <li>Nude videos &amp; photo galleries</li>
              <li>Watch sexy &amp; engaging live streams</li>
              <li>Chat &amp; interact with our lovely Anchors</li>
            </ul>}
        </div>
        {!authenticated && <EmailValidatorField errorMessage={errorMessage} user={user} />}
        {!isChristmasPromo && !isCyberMondayPromo && <div className="container">
          <h4 className="important-info">
            A unique link is sent via email on every calendar purchase. Please use this link to get your promotion.
            Please check your mail for emails from shop@nakednews.com. Also check your spam folder.
            Please move the mail to your inbox and follow the instructions provided.
          </h4>
        </div>}
        {renderAnchorsList()}
      </div>
    </div>
  );
}

export default DiscountsPage;

DiscountsPage.propTypes = {
  activeCampaign: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
  isChristmasPromo: PropTypes.bool,
  isCyberMondayPromo: PropTypes.bool,
};

DiscountsPage.defaultProps = {
  isCyberMondayPromo: false,
  isChristmasPromo: false,
  className: '',
};
